module.exports = __webpack_public_path__ + "static/media/most-loved.daa99c14.svg";